module.exports = __webpack_public_path__ + "media/next_game_start_4.82256be8.mp3";